import Model, { attr, belongsTo } from '@ember-data/model';
import type AutomatedMessageRuleModel from 'uplisting-frontend/models/automated-message-rule';

// Mirrors the API's filter shape exactly
// (apps/api/serializers/automated_message_rule_filter.rb).
export default class AutomatedMessageRuleFilterModel extends Model {
  @attr('string') entity!: string;
  @attr('string') attribute!: string;
  @attr('string') operand!: string;
  @attr('string') value!: string;

  @belongsTo('automated-message-rule', {
    inverse: 'automatedMessageRuleFilters',
    async: false,
  })
  automatedMessageRule!: AutomatedMessageRuleModel;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'automated-message-rule-filter': AutomatedMessageRuleFilterModel;
  }
}
